import { sanitizeAlphanumericCnpj } from 'utils/cnpjUtils';

export const CpfCnpjMask = (value: string) => {
  const cnpjMaskFormatter = (str: string) => {
    let clean = sanitizeAlphanumericCnpj(str);
    clean = clean.substring(0, 14);
    clean = clean.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2');
    clean = clean.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3');
    clean = clean.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3/$4');
    clean = clean.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})([0-9])/, '$1.$2.$3/$4-$5');
    return clean;
  };

  const cpfMaskFormatter = (str: string) => {
    return str
      .replace(/\D+/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1-$2');
  };

  const alphanumChars = sanitizeAlphanumericCnpj(value);
  const hasLetters = /[A-Za-z]/.test(value);
  const inputLength = alphanumChars.length;

  if (hasLetters) return cnpjMaskFormatter(value);
  return inputLength && inputLength > 11 ? cnpjMaskFormatter(value) : cpfMaskFormatter(value);
};

export const CpfMask = (value: string) => {
  const cpfMaskFormatter = (str: string) => {
    return str
      .replace(/\D+/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  };

  const inputLength = value.match(/\d+/g)?.join('').length;
  return inputLength && cpfMaskFormatter(value);
};

export const TelefoneMask = (value: string) => {
  const celularFormatter = (str: string) => {
    return str
      .replace(/\D+/g, '')
      .replace(/(\d{0})(\d)/, '$1($2')
      .replace(/(\d{2})(\d)/, '$1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1');
  };

  const telefoneFormatter = (str: string) => {
    return str
      .replace(/\D+/g, '')
      .replace(/(\d{0})(\d)/, '$1($2')
      .replace(/(\d{2})(\d)/, '$1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  };
  const inputLength = value.match(/\d+/g)?.join('').length;
  return inputLength && inputLength > 10 ? celularFormatter(value) : telefoneFormatter(value);
};

export const CepMask = (value: string) => {
  const cepMaskFormatter = (str: string) => {
    return str
      .replace(/\D+/g, '')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{3})\d+?$/, '$1');
  };

  const inputLength = value.match(/\d+/g)?.join('').length;
  return inputLength && cepMaskFormatter(value);
};

export const ContaDepositoMask = (value: string) => {
  const contaDepositoFormatter = (str: string) => {
    return str
      .replace(/\D+/g, '')
      .substring(0, 12)
      .replace(/(\d{8})(\d{1})(\d{3})/, '$1.$2.$3');
  };

  const inputLength = value.match(/\d+/g)?.join('').length;
  return inputLength ? contaDepositoFormatter(value) : undefined;
};
